import React from 'react';

function ManagesReportPage() {
    return <div>ManagesReportPage</div>;
}

export default ManagesReportPage;
